module.exports = __webpack_public_path__ + "img/CloudMain.f832aa5.svg";